import CollapsedWhiteBox from './CollapsedWhiteBox';

export default CollapsedWhiteBox;
